import Repository from './repository';

const resource = '/twoFA';
export default {
	getVerificationMethods() {
		return Repository.getWithAuth(`${resource}/verification-methods`);
	},

	prepareTwoFA(payload) {
		return Repository.postWithAuth(`${resource}/prepare`, payload);
	},

	validateTwoFA(payload) {
		return Repository.postWithAuth(`${resource}/validate`, payload);
	},

	preValidateTwoFA(payload) {
		return Repository.postWithAuth(`${resource}/pre-validate`, payload);
	},
	twoFALogin(payload) {
		return Repository.postWithAuth(`${resource}/twoFALogin`, payload);
	},
	enableTwoFA(payload) {
		return Repository.postWithAuth(`${resource}/enable`, payload);
	},

	disableTwoFA(payload) {
		return Repository.postWithAuth(`${resource}/disable`, payload);
	},

	regenerateRecoveryCodes(payload) {
		return Repository.postWithAuth(
			`${resource}/regenerate-recovery-codes`,
			payload
		);
	},

	changeVerificationMethod(payload) {
		return Repository.postWithAuth(
			`${resource}/change-verification-method`,
			payload
		);
	},
};
